import { render, staticRenderFns } from "./chooseClass.vue?vue&type=template&id=addd7bfe&scoped=true&"
import script from "./chooseClass.vue?vue&type=script&lang=js&"
export * from "./chooseClass.vue?vue&type=script&lang=js&"
import style0 from "./chooseClass.vue?vue&type=style&index=0&id=addd7bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addd7bfe",
  null
  
)

export default component.exports